"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultVideoState = {
    src: '',
};
//# sourceMappingURL=state.js.map